export const DEMO_TIME_OPTIONS = [
  "Weekday morning (9am–12pm ET)",
  "Weekday afternoon (12pm–5pm ET)",
  "Weekday evening (5pm–8pm ET)",
  "Weekend morning (9am–12pm ET)",
  "Weekend afternoon (12pm–5pm ET)",
  "Any time works",
] as const;

export type DemoTimeOption = typeof DEMO_TIME_OPTIONS[number];
